'use client';

import { c as _c } from "react/compiler-runtime";
import { type OptionTableFilter, TableFilter } from '@morpho-org/ui-v6/client';
import { Separator } from '@repo/ui';
import { memo, useId } from 'react';
import type { AssetFilter } from '@/helpers/filter/table';
interface TagAssetFilterProps {
  tagOptions: OptionTableFilter<AssetFilter>[];
  disabled: boolean;
}
const TagAssetFilter = t0 => {
  const $ = _c(7);
  const {
    tagOptions,
    disabled
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== disabled || $[1] !== id || $[2] !== tagOptions) {
    t1 = <div className="py-2xs px-xs gap-2xs flex flex-wrap items-center"><TableFilter id={id} options={tagOptions} disabled={disabled} /></div>;
    $[0] = disabled;
    $[1] = id;
    $[2] = tagOptions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Separator />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default memo(TagAssetFilter);